<template>
    <div class="content-block" v-bind:class="templateClass">
        <div class="content-block--background" ref="contentBackground"></div>
        <div class="content-block--content">
            <div class="content-block--title">
                <h2 class="title" v-if="this.item.title != undefined">{{ this.item.title }}</h2>
                <h3 class="subtitle" v-if="this.item.subTitle != undefined">{{ this.item.subTitle }}</h3>
                <h4 class="under-title" v-if="this.item.underTitle != undefined">{{ this.item.underTitle }}</h4>
            </div>
            <div class="content-block--play" v-if="this.item.videoUrl != undefined"  v-on:click="toggleVideo" ref="playButton">
                <div class="content-block--play--circle" ref="playCircle"></div>
                <img src="static/images/play.png" alt="play button" />
            </div>

            <div class="content-block--slider"  v-if="this.item.slider!= undefined" ref="slider">
                <div class="content-block--slider--container">
                    <ul class="content-block--slider--wrapper">
                        <li class="content-block--slide">
                            <img src="static/images/slide-1.jpg" alt="slider image" />
                        </li>
                        <li class="content-block--slide">
                            <img src="static/images/slide-2.jpg" alt="slider image" />
                        </li>
                        <li class="content-block--slide">
                            <img src="static/images/slide-3.jpg" alt="slider image" />
                        </li>
                        <li class="content-block--slide">
                            <img src="static/images/slide-4.jpg" alt="slider image" />
                        </li>
                    </ul>
                </div>
                <div class="content-block--slider--next" v-on:click="slideRight"></div>
                <div class="content-block--slider--prev" v-on:click="slideLeft"></div>
            </div>

            <div class="content-block--awards"  v-if="this.item.awards != undefined">
                <div class="content-block--awards--left">
                    Recent awards for our work<br />
                    with the Ministry of Defence
                </div>
                <div class="content-block--awards--right">
                    <img src="static/images/awards.png" srcset="static/images/awards@2x.png 2x" alt="awards" />
                </div>
            </div>

            <div class="content-block--footer">
                <p class="content-block--client" v-if="this.item.footerTop != undefined">
                    {{ this.item.footerTop }}
                </p>
                <p class="content-block--credits" v-if="this.item.footerBottom != undefined">
                    {{ this.item.footerBottom }}
                </p>
            </div>

            <div class="content-block--clients"  v-if="this.item.clients != undefined" v-html="this.item.clients">
            </div>

            <div class="content-block--teaser" v-if="this.item.teaser != undefined">
                <h2 class="teaser">{{ this.item.teaser }}</h2>
                <h3 class="under-teaser">{{ this.item.underTeaser }}</h3>
            </div>

            <div class="content-block--video" v-on:click="toggleVideo" ref="videoBlock">
                <div class="content-block--video--close">
                    <span></span>
                    <span></span>
                </div>
                <div class="content-block--video--container">
                    <div class="wrapper" ref="videoWrapper">
                    </div>
                </div>
            </div>

            <div class="content-block--more" v-on:click="moveDown">
                More work
                <span><img src="static/images/arrow-down.png" /></span>
            </div>
        </div>
    </div>
</template>

<script>
import { TweenLite, TimelineLite, Power2 } from 'gsap';
import Player from '@vimeo/player';

export default {
    name: 'ContentBlock',
    props: [
        'item'
    ],
    data () {
        return {
            templateClass: 'content-block--' + this.item.template,
            moving: false,
            count: 1,
            endValue: 0,
            moveValue: 0,
            videoOpen: false
        }
    },
    mounted() {
        this.$refs.contentBackground.style.backgroundImage = "url(" + 'static/images/' + this.item.background + ")";

        if (this.$refs.slider) {
            this.initSlider();
            this.autoSlide();
        }
    },
    methods: {
        toggleVideo: function () {
            let headerBlock = document.querySelector('.header-block');
            let easeAnim = Power2.easeOut;
            let tl = new TimelineLite();

            if (this.videoOpen === false) {
                this.$parent.videoOpen = true;
                this.videoOpen = true;

                this.toggleVimeo();

                TweenMax.to(this.$refs.contentBackground, 1.2, {
                    scale: 1.1,
                    ease: easeAnim,
                    delay: .5
                });

                TweenMax.to(headerBlock, 1, {
                    top: -100,
                    ease: easeAnim
                });

                tl.to(this.$refs.videoBlock, 1, {
                    opacity: 1,
                    className:"+=active",
                    ease: easeAnim
                }, '-=1');

                tl.to(this.$refs.playCircle, .1, {
                    width: 400,
                    height: 400,
                    ease: easeAnim
                }, '-=1');

                tl.to(this.$refs.playButton, .5, {
                    opacity: 0,
                    ease: easeAnim
                }, '-=1.3');

                tl.to(this.$refs.videoWrapper, .3, {
                    opacity: 1,
                    ease: easeAnim
                });
            } else {
                this.$parent.videoOpen = false;
                this.videoOpen = false;

                tl.to(this.$refs.videoWrapper, .3, {
                    opacity: 0,
                    ease: easeAnim,
                    onComplete: this.toggleVimeo
                });

                tl.to(this.$refs.videoBlock, 1, {
                    opacity: 0,
                    ease: easeAnim
                }, '-=.3');

                tl.to(this.$refs.videoBlock, .1, {
                    className:"-=active",
                    ease: easeAnim
                });

                tl.to(this.$refs.playButton, .5, {
                    opacity: 1,
                    ease: easeAnim
                }, '-=1.1');

                tl.to(this.$refs.playCircle, .1, {
                    width: 110,
                    height: 110,
                    ease: easeAnim
                }, '-=.9');

                TweenMax.to(this.$refs.contentBackground, 1.2, {
                    scale: 1,
                    x: -50 + '%',
                    y: -50 + '%',
                    ease: easeAnim,
                    delay: .5
                });

                TweenMax.to(headerBlock, 1, {
                    top: 0,
                    ease: easeAnim
                });
            }
        },

        toggleVimeo: function() {
            const player = new Player(this.$refs.videoWrapper, {
                id: this.item.videoUrl,
                width: 640
            });

            let mq = window.matchMedia( "(max-width: 1023px)" );
            if (!mq.matches) {
                if (this.videoOpen === true) {
                    player.play();
                } else {
                    player.pause();
                }
            }
        },

        initSlider: function() {
            let slider = document.querySelector('.content-block--slider--wrapper');
            let allSlides = slider.querySelectorAll('li');
            let slidesAmount = allSlides.length;
            let firstSlide = allSlides[0];
            let lastSlide = allSlides[slidesAmount -1];
            this.endValue = allSlides.length;

            let cloneFirstSlide = firstSlide.cloneNode(true);
            let cloneLastSlide = lastSlide.cloneNode(true);

            slider.appendChild(cloneFirstSlide);
            slider.insertBefore(cloneLastSlide, slider.childNodes[0]);

            let totalItems = slidesAmount + 2;
            let sliderWidth = (totalItems * 100) + '%';
            let itemWidth = (100 / totalItems) + '%';

            slider.style.left = -100 + '%';
            slider.style.width = sliderWidth;

            allSlides = slider.querySelectorAll('li');

            for (let i = 0; i < allSlides.length; i++) {
                allSlides[i].style.width = itemWidth;
            }
        },

        slideLeft: function() {
            if (this.moving === false) {
                this.count--;
                this.animateSlider();
            }
        },

        slideRight: function() {
            if (this.moving === false) {
                this.count++;
                this.animateSlider();
            }
        },

        autoSlide: function() {
            let _this = this;

            timeout();

            function timeout() {
                setTimeout(function () {
                    _this.slideRight();
                    timeout();
                }, 5000);
            }
        },

        animateSlider: function() {
            let slider = document.querySelector('.content-block--slider--wrapper');
            this.moving = true;
            this.moveValue = (this.count * -100) + '%';
            let sliderStartValue = (this.endValue * -100) + '%';
            let tl = new TimelineLite();

            if (this.count === 0) {
                this.count = this.endValue;
                this.moveLeft(tl);
                tl.to(slider, 0, { left: sliderStartValue });
            } else if (this.count > this.endValue) {
                this.count = 1;
                this.moveLeft(tl);
                tl.to(slider, 0, { left: -100 + '%' });
            } else {
                this.moveLeft(tl);
            }
        },

        moveLeft: function(tl) {
            let slider = document.querySelector('.content-block--slider--wrapper');
            tl.to(slider, .8, { left: this.moveValue, onComplete: this.doneMoving });
        },

        doneMoving: function() {
            this.moving = false;
        },

        moveDown: function(e) {
            this.$parent.moveSlider(e);
        }
    }
}
</script>



// WEBPACK FOOTER //
// ContentBlock.vue?5493945d